<div class="ask-as-wrapper">
    <div class="ask-us-btn anim-to-disable" 
    (mouseenter) ="mouseEnterBtn()"  
    (mouseleave) ="mouseLeaveBtn()" [ngClass]="{'disable-anim': isLinksActive || isFormActivate || disableAnimation}" *ngIf="!displayAboutAsOrigin" (click)="changeLinksState()">
        <span class="anim-to-disable" [ngClass]="{'disable-anim': isLinksActive || isFormActivate || disableAnimation}">
            שאל
            <br>אותנו
        </span>
    </div>
</div>


<div class="ask-as-extenal-links-wrapper" [ngClass]="{'links-active': isLinksActive, 'links-not-active': !isLinksActive && !firstLinksActive}">
    <div class="ask-us-link email-link" title="אימייל" (click)="changeFormStat()">
        <fa-icon [icon]="['fas', 'envelope']" ></fa-icon>

    </div>

    <div class="ask-us-link msg-link" title="מסנג'ר" (click)="openMsgWindow()"></div>


    <div class="ask-us-link watsapp-link" title="וואצאפ" (click)="openWatsappWindow()"></div>
    <!-- <div class="ask-us-link live-chat-link" title="צ'ט מיידי" (click)="openChatBotWindow()"></div> -->
</div>

<div *ngIf="!displayAboutAsOrigin" (click)="clickOnBlankArea()" [ngClass]="{'ask-us-form-frame-active': isFormActivate, 'ask-us-form-frame-no-active': !isFirstLoad&& !isFormActivate}"
    class="ask-us-form-wrapper">
    <div class="ask-us-form-wrapper-cube">


                <div (click)="preventClick($event)" 
                [ngClass]="{'ask-us-form-wrapper-active': isFormActivate, 'ask-us-form-wrapper-no-active': !isFirstLoad&& !isFormActivate}"
                    class=" ask-us-frame ">
                    <div class="close-wrapper" (click)="changeFormStat()">
                            <div  >X</div>
                    </div>
                    <div class="row">
                            
                        <div class="col-md-12 ask-as-logo">

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 ">

                            <div class="ask-us-title">
                                שאל אותנו
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            
                            <div class="col-sm-12 input-field">

                                <input class="col-sm-12 special-font" type="text" (keyup)="validateSpacificField($event, 0)" placeholder="שם*" [(ngModel)]="name">

                                <div class="form-control-label alert-danger" *ngIf="fieldHasError[0]">עליך למלא שם</div>
                            </div>
                            <div class="col-sm-12 input-field">
                                <input class="col-sm-12 special-font" type="email" (keyup)="validateSpacificField($event, 2)" placeholder="אמייל*" [(ngModel)]="email"
                                />
                                <div class="form-control-label alert-danger" *ngIf="fieldHasError[1]">עליך למלא אימייל</div>

                            </div>
                            <div class="col-sm-12 input-field">
                                <input class="col-sm-12 special-font" type="email" 
                                (keyup)="validateSpacificField($event, 4)" onpaste="return false"
                                placeholder="אימות אמייל*" [(ngModel)]="copyEmail"
                                />
                                <div class="form-control-label alert-danger" *ngIf="fieldHasError[4]">אימייל אימות חייב להיות זהה לאימייל</div>

                            </div>
                            <div class="col-sm-12 input-field">
                                <input class="col-sm-12 special-font" type="tel" placeholder="מספר טלפון" [(ngModel)]="phone" />
                            </div>
                            <div class="col-sm-12 input-field">
                                <textarea class="col-sm-12 special-font" rows="2" (keyup)="validateSpacificField($event, 2)" placeholder="...*" [(ngModel)]="content"></textarea>
                                <div class="form-control-label alert-danger" *ngIf="fieldHasError[2]">עליך למלא תוכן להודעה שלך</div>

                            </div>
                            <div class="col-sm-12 input-field recaptcha-wrapper" *ngIf="disaplayRobot">
                                <re-captcha *ngIf="isFormActivate" class="recaptcha" (resolved)="resolved($event)" siteKey="{{recaptchaKey}}"></re-captcha>
                                <div class="form-control-label alert-danger" *ngIf="fieldHasError[4]"> אנא סמן ב-V את תיבת "אני לא רובוט" </div>


                            </div>
                            <div class="col-sm-12 input-field">
                                <input class="col-sm-12 submit-btn-online-ask-as" (click)="sendMail()" type="button" value="שלח" />
                            </div>


                            <div class="col-sm-12 input-field">
                                <div class="contact-qoute">
                                    קבלת תשובה עד יום עסקים אחד
                                    <div>
                                        שעות מענה ימים א-ה בין השעות 9:00-17:00

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


    </div>
</div>
<div class="msg-wrapper" *ngIf="displaySucceedMsg || displayFailddMsg">


    <div *ngIf="displaySucceedMsg" class="success-msg">
        <span class="close-x-msg" (click)="displaySucceedMsg=false;">x</span>
        הודעתך נשלחה בהצלחה!

    </div>
    <div *ngIf="displayFailddMsg" class="faild-msg">
        <span class="close-x-msg" (click)="displayFailddMsg=false;">x</span>
        אופס! התרחשה תקלה. ההודעה לא נשלחה. אנא נסה שוב מאוחר יותר</div>
</div>
<app-chatbot *ngIf="appsetting.displayChatBot"></app-chatbot>